export const formatLandscapePrefix = (idWithLandscape: string) =>
	idWithLandscape.split(/^\w+\./)[1]
